import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
// project imports
import { loadingBarReducer } from 'react-redux-loading-bar';
import authDialog from '../containers/AuthModal/reducer';
import forgetPasswordForm from '../containers/ForgetPasswordForm/reducer';
import loginForm from '../containers/LoginForm/reducer';
import resetPasswordForm from '../containers/ResetPassword/reducer';
import signUpForm from '../containers/SignUpForm/reducer';
import * as AuthenticationReducers from '../containers/Authenticator/reducers';
import snackbarStatus from '../containers/ApplicationSnackbar/reducer';
import welcomeMessage from '../containers/WelcomeMessage/reducer';
import vcFeed from '../containers/VisualConversationFeed/reducer';
import DrawingToolReducer from '../containers/DrawingTool/reducer';
import profileView from '../containers/ProfileView/reducer';

export default history => combineReducers({
  forgetPasswordForm,
  authDialog,
  loginForm,
  resetPasswordForm,
  signUpForm,
  snackbarStatus,
  vcFeed,
  welcomeMessage,
  DrawingToolReducer,
  profileView,
  loadingBar: loadingBarReducer,
  ...AuthenticationReducers,
  router: connectRouter(history),
});



// WEBPACK FOOTER //
// ./src/reducers/index.js